<template>
    <div class="frame-login-bg">
        <div class="frame-login-container">
            <div class="frame-login-left" style="background-color: #0c2e66;"></div>
            <div class="frame-login-right">
                <!-- <div class="frame-login-title">账号登录</div> -->
                <div style="display: block; line-height: 120px; margin: 20px auto; text-align: center; font-size: 36px; font-weight: bold;">
                    用户分销管理系统</div>
                <div class="frame-login-form">
                    <p class="frame-login-label">账号名称：</p>
                    <el-input v-model="loginForm.name"></el-input>
                    <p class="frame-login-label">登录密码：</p>
                    <el-input v-model="loginForm.password" type="password"></el-input>
                    <p class="frame-login-label">验证码：</p>
                    <div class="frame-login-auth">
                        <el-input class="frame-login-authinput" v-model="loginForm.verify"></el-input>
                        <img class="frame-login-authimg" alt="验证码" @click="getVerify()" :src="verifyImage" />
                        <span class="frame-login-authswitch" @click="getVerify()">点击换一个</span>
                    </div>
                    <el-button class="frame-login-submit" type="primary" @click="loginClick">系统登录</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { API, doPost } from "@/api/api.js"

export default {
    data: function () {
        return {
            loginForm: {
                name: "",
                password: "",
                verify: ""
            },
            verifyImage: "",
        }
    },
    methods: {
        loginClick: async function () {
            let resultObj = await doPost(API.PUBLIC.LOGIN, this.loginForm);
            if (resultObj.success) {
                localStorage.setItem("AUTH-ADMIN", resultObj.code);
                this.$message.success(resultObj.msg);
                this.$router.push("/");
            }
            else {
                this.$message.error(resultObj.msg);
            }
        },
        getVerify: function () {
            let token = new Date().getTime();
            this.verifyImage = process.env.VUE_APP_BASE_API + API.PUBLIC.VERIFY + "?token=" + token;
        }
    },
    created: function () {
        this.getVerify();
    }
}
</script>
<style lang="less" scoped>
    .frame-login-bg {
        height: 100vh;
        background-color: rgb(197, 209, 235);
        padding-top: calc(50vh - 340px);
    }

    .frame-login-container {
        width: 1020px;
        display: flex;
        height: 680px;
        margin: 0px auto;
    }

    .frame-login-left {
        width: 435px;
        padding: 30px;
        background-color: #589dfb;
        height: 680px;
        background-image: url(@/assets/img/login-left-icon.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        background-origin: content-box;
    }

    .frame-login-right {
        flex-grow: 1;
        background-color: #FFFFFF;
        height: 680px;
        padding-top: 30px;
    }

    .frame-login-title {
        height: 120px;
        line-height: 120px;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        color: #348aff;
    }

    .frame-login-form {
        text-align: left;
        width: 400px;
        margin: 0px auto;
    }

    .frame-login-label {
        height: 30px;
        line-height: 30px;
        font-size: 18px;
    }

    .frame-login-submit {
        width: 100%;
        margin-top: 50px;
        font-size: 14px;
        height: 40px;
    }

    .frame-login-auth {
        display: flex;
        align-items: center;
    }

    .frame-login-authinput {
        flex-shrink: 1;
    }

    .frame-login-authimg {
        display: block;
        margin: 0px 7px;
        height: 36px;
    }

    .frame-login-authswitch {
        color: #0000FF;
        cursor: pointer;
        display: block;
        width: 150px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
    }

    .frame-login-submit {
        widows: 100%;
    }
</style>